import { categoryLabels } from "../types";

interface CategoryBadgeProps {
  category: string;
}

const categoryStyles: Record<
  string,
  {
    base: string;
    glow: string;
  }
> = {
  "print-quality": {
    base: "border-cyan-300/20 bg-cyan-400/10 text-cyan-300",
    glow: "shadow-[0_0_10px_rgba(34,211,238,0.08)]",
  },
  "white-ink": {
    base: "border-slate-300/20 bg-slate-300/10 text-slate-200",
    glow: "shadow-[0_0_10px_rgba(226,232,240,0.08)]",
  },
  adhesion: {
    base: "border-emerald-300/20 bg-emerald-400/10 text-emerald-300",
    glow: "shadow-[0_0_10px_rgba(52,211,153,0.08)]",
  },
  hardware: {
    base: "border-rose-300/20 bg-rose-400/10 text-rose-300",
    glow: "shadow-[0_0_10px_rgba(251,113,133,0.08)]",
  },
  film: {
    base: "border-fuchsia-300/20 bg-fuchsia-400/10 text-fuchsia-300",
    glow: "shadow-[0_0_10px_rgba(232,121,249,0.08)]",
  },
  "heat-press": {
    base: "border-amber-300/20 bg-amber-400/10 text-amber-300",
    glow: "shadow-[0_0_10px_rgba(252,211,77,0.08)]",
  },
  environment: {
    base: "border-sky-300/20 bg-sky-400/10 text-sky-300",
    glow: "shadow-[0_0_10px_rgba(56,189,248,0.08)]",
  },
};

export function CategoryBadge({ category }: CategoryBadgeProps) {
  const label = categoryLabels[category] || category;

  const style =
    categoryStyles[category] || {
      base: "border-white/10 bg-white/5 text-white/65",
      glow: "",
    };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] transition ${style.base} ${style.glow}`}
    >
      {label}
    </span>
  );
}
